export interface JobTask {
  progressType: ProgressType;
  jobParams?: Record<string, any>;
}

export enum ProgressType {
  BRD_CODING = 'brands',
  SEG_CODING = 'segment',
  PKS_CODING = 'packsize',
  BRD_TAGGING = 'tagbrands',
  DATA_ARCHIVE = 'saveds',
  TPL_COPY = 'copytpl',
  TPL_ONGOING = 'ongoing',
  CAT_DELIVER = 'deliver',
  BUILD_COMBO = 'savecbds',
  DATA_IMPORT = 'dataImport',
  DATA_FIX = 'dataFix',
}
